import { DatePipe } from '@angular/common';
import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';

@Directive({
  selector: '[DateFormat]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => DateDirective), multi: true },
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DateDirective), multi: true },
    DatePipe
  ]
})
export class DateDirective implements Validator, ControlValueAccessor {
  testDate: string;

  constructor(private renderer: Renderer2, private elRef: ElementRef, private datePipe: DatePipe) {}

  writeValue(obj: any): void {
    if (obj) {
      const textDate = this.datePipe.transform(obj, 'dd-MM-yyyy');
      this.testDate = textDate;
      this.renderer.setProperty(this.elRef.nativeElement, 'value', textDate);
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  // Not Used
  registerOnTouched(fn: any): void {}

  private propagateChange = (_: any) => {};

  validate(c: AbstractControl): { [key: string]: any } {
    if (!this.testDate) {
      return null;
    }

    const regex = new RegExp(/\d{2}-\d{2}-\d{4}/);

    if (!regex.test(this.testDate)) {
      return { validDate: false };
    }

    const values = this.testDate.split('-');
    const date = new Date(parseInt(values[2], 10), parseInt(values[1], 10) - 1, parseInt(values[0], 10));

    if (isNaN(date.getTime())) {
      return { validDate: false };
    }

    // Block dates in the future (for DateOfBirth purposes)
    const currentDate = new Date();
    const pastDate = new Date();
    pastDate.setUTCFullYear(currentDate.getFullYear() - 100);
    if (date > currentDate || date < pastDate) {
      return { valueNotAllowed: true };
    }

    // Reverse Validate Date
    if (date.getFullYear() !== parseInt(values[2], 10) || date.getMonth() !== parseInt(values[1], 10) - 1) {
      return { validDate: false };
    }

    return null;
  }

  @HostListener('input', ['$event.target.value']) onChange = (value: any) => {
    this.testDate = value;

    // Auto-add hyphens
    if ((value.length === 3 || value.length === 6) && !value.endsWith('-')) {
      value = value.substring(0, value.length - 1) + '-' + value.substring(value.length - 1);
      this.elRef.nativeElement.value = value;
    }

    const values = value.split('-');
    const date = new Date(Date.UTC(values[2], values[1] - 1, values[0]));

    this.propagateChange(date);
  };

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(event.key) ||
      (event.ctrlKey && event.key === 'a') ||
      (event.ctrlKey && event.key === 'c') ||
      (event.ctrlKey && event.key === 'v') ||
      (event.ctrlKey && event.key === 'x') ||
      event.key === '-' ||
      event.key === 'Home' ||
      event.key === 'End' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight' ||
      event.key === 'Backspace' ||
      event.key === 'Delete'
    ) {
      return;
    } else {
      event.preventDefault();
    }
  }
}
